import React from 'react';
import { useLanguage } from '../lib/i18n';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex items-center gap-2 text-[10px] tracking-[0.2em] font-medium" data-id="element-219">
      <button onClick={() => setLang('es')} className={`transition-colors duration-300 ${lang === 'es' ? 'text-terracotta font-bold' : 'text-volcanic/60 hover:text-volcanic'}`} data-id="element-220">
        ES
      </button>
      <span className="text-volcanic/30" data-id="element-221">|</span>
      <button onClick={() => setLang('en')} className={`transition-colors duration-300 ${lang === 'en' ? 'text-terracotta font-bold' : 'text-volcanic/60 hover:text-volcanic'}`} data-id="element-222">
        EN
      </button>
    </div>;
}